import { IHotspotAnalysis } from '../services/analytics/hotspots.model';

/**
 * The comparison the hotspot figures were worked out against, read from the payload rather than from
 * the period selector. The API echoes the comparison period it used, so the Hotspot Analysis page,
 * its drawers and the PDF print page all name and total it the same way.
 *
 * prevTotal is the prior-period footprint from the reduction trajectory (keyed by year).
 */
export const getHotspotComparison = (data?: IHotspotAnalysis): { prevTotal?: number; prevLabel?: string } => {
  if (!data?.comparison) return {};
  const comparison = data.comparison;
  const row = data.reduction.trajectory.find((t) => String(t.year) === String(comparison.calendarYear));
  return {
    prevTotal: row?.value ?? undefined,
    prevLabel: `vs ${comparison.friendlyName}`,
  };
};
